<template>
  <div>
    <form id="form-modal" enctype="multipart/form-data">
      <!-- title input -->
      <div class="form-group">
        <label class="label-form">Upload Images:</label>
        <div v-if="isLoader">
          <b-row >
            <b-col cols="12">
              <b-skeleton-img no-aspect height="150px"></b-skeleton-img>
            </b-col>
          </b-row>
          <b-row class="text-right">
            <b-col cols="11"></b-col>
            <b-col cols="1">
              <b-skeleton-img no-aspect height="40px"></b-skeleton-img>
            </b-col>
          </b-row>
        </div>
        <vue-dropzone v-show="!isLoader" style="min-height: 196px" ref="myVueDropzone" id="dropAttach" :options="dropzoneOptions">
        </vue-dropzone>
      </div>
      <!-- buttons -->
      <div v-show="!isLoader" class="form-footer text-right">
        <button type="button" style="display: none; padding: 0.525rem 1.449rem;" class="btn btn-danger btn-sm ml-1 resetBtn" @click="resetForm">
          Remove all
        </button>
        <button type="button" class="btn-basic ml-1 saveBtn" @click="save">
          Save
        </button>
      </div>
      <hr />
    </form>

    <image-table v-show="!isLoader" :Images="Images" :totalPages="totalPages" :page="page" :totalImages="totalImages" @setPage="setPage">
    </image-table>
  </div>
</template>
<script>
  import ImageTable from "./image_table";
  import $ from "jquery";
  import helpers from "@/helpers.js";
  import vue2Dropzone from "vue2-dropzone";
  import "vue2-dropzone/dist/vue2Dropzone.min.css";
  export default {
    name: "all_media.vue",
    components: {
      vueDropzone: vue2Dropzone,
      ImageTable,
    },
    data: function () {
      var supportedImageFormats = [
        ".jpeg",
        ".jfif",
        ".bmp",
        ".jpg",
        ".png",
        ".gif",
      ];
      var self = this;
      return {
        isLoader: true,
        limit: 18,
        page: 0,
        maxFileSizeInBytes: "",
        maxFileSizeInMb: "",
        postMaxSizeInBytes: "",
        postMaxSizeInMb: "",
        formSizeInbytes: 0,
        totalImages: 0,
        supportedImageFormats: supportedImageFormats,
        mediaForm: {},

        config: {
          uploader: {
            insertImageAsBase64URI: true,
          },
        },
        dropzoneOptions: {
          url: "javascript::void(0)", // This is broken link which is not going to upload image.
          acceptedFiles: supportedImageFormats.join(", ") + ",",
          maxFilesize: 2,
          addRemoveLinks: true,
          timeout: 50000,
          init: function () {
            this.on("addedfile", function (file) {
              if (file.size > self.maxFileSizeInBytes) {
                this.$toast.error('Image size can not be more than 2Mb');
                this.removeFile(file);
              } else {
                $(".resetBtn").show();
              }
              return false;
            });
            this.on("removedfile", function (file) {
              var fileCount;
              fileCount = this.files.length;
              if (fileCount == 0) {
                $(".resetBtn").hide();
              }
            });
          },
          error: function (file, response, xhr) {
            if (response == "You can't upload files of this type.") {
              var fileRef;
              (fileRef = file.previewElement) != null
                ? fileRef.parentNode.removeChild(file.previewElement)
                : void 0;
              self.$store.dispatch("message/update", {
                title: "File upload error!",
                body:
                  "Here is the list of supported files:" +
                  "\n" +
                  supportedImageFormats.join(", ") +
                  "\n",
                class: "warning",
                confirm: false,
              });
            }
            return false;
          },
        },
      };
    },
    created: function () {
      this.mediaForm = {
        attachment: [],
      };
      this.page = helpers.getPageQuery();
    },
    computed: {
      Images: function () {
        // let loader = this.$loading.show({
        //   loader: "dots",
        //   container: this.fullPage ? null : this.$refs.formContainer,
        // });
        this.isLoader = true;
        setTimeout(() =>{
          // loader.hide()
          this.isLoader = false;
        } , 500);
        return this.$store.getters["mediauploads/Images"];
        
      },
      totalPages: function () {
        return this.$store.getters["mediauploads/totalPages"];
      },
    },
    watch: {
      page: function (val) {
        this.$store
          .dispatch("mediauploads/getAllImages", [val, this.limit])
          .then((response) => {
            let res = response;
            this.maxFileSizeInBytes = helpers.convertMbToBytes(res.maxUploadSize);
            this.maxFileSizeInMb = res.maxUploadSize;
            this.postMaxSizeInBytes = helpers.convertMbToBytes(res.postMaxSize);
            this.postMaxSizeInMb = res.postMaxSize;
            this.totalImages = res.total;
          });
        setTimeout(() => { }, 2000);
      },
    },
    methods: {
      setPage(page) {
        this.page = page;
        this.$router.push("mediauploads?page=" + page);
      },
      save() {
        $(".mycheckboxForImage").prop("checked", false);
        $(".mycheckBox").hide();
        this.mediaForm.attachment = this.$refs.myVueDropzone.getAcceptedFiles();
        var media = this.mediaForm;
        var self = this;
        self.formSizeInbytes = 0;
        // var size = this.mediaForm.attachment.size();
        for (var i = 0; i < this.mediaForm.attachment.length; i++) {
          self.formSizeInbytes += this.mediaForm.attachment[i].size;
        }
        if (this.mediaForm.attachment.length == 0) {
          this.$toast.warning('Please upload an image first');
        } else if (this.mediaForm.attachment.length >= 16) {
          this.$toast.warning('You can upload maximum of 15 images at a time');
        } else if (this.formSizeInbytes >= this.postMaxSizeInBytes) {
          this.$toast.error("Your upload Size in greater than " + this.postMaxSizeInMb + "b");
        } else {
          this.isLoader=true;
          this.$store.dispatch("mediauploads/uploadImage", media)
            .then(() => {
              this.$toast.success('Image uploaded successfully');
              $(".checkAll").prop("checked", false);
              this.$refs.myVueDropzone.removeAllFiles();
              $(".resetBtn").hide();
              this.isLoader=false;
            })
            .catch((error) => {
              let response = error.response;
              // send error message
              this.$toast.error(response.data.message);
              this.isLoader=false;
            });
          $(".resetBtn").attr("disabled", false);
        }
      },
      resetForm() {
        this.$toast.error('All images removed successfully');
        this.$refs.myVueDropzone.removeAllFiles();
        $(".resetBtn").hide();
      },
    },
  };
</script>

<style>
  .dropzone {
    border: 2px solid #22b9ff;
  }

  .form-modal {
    margin: 0px 10px 0px 10px;
  }

  .deleteMultiple {
    margin-bottom: 10px;
  }

  .deleted {
    margin-bottom: 10px;
  }

  .dropzone .dz-preview .dz-details {
    z-index: 0 !important;
    padding: 1em 0.5em !important;
  }

  .dropzone .dz-preview .dz-details .dz-size {
    /*margin-bottom: 1em;*/
    font-size: 12px !important;
    margin-bottom: 0px !important;
  }

  .dropzone .dz-message {
    margin: 4em 0 !important;
  }

  .dropzone .dz-preview .dz-image {
    z-index: 0 !important;
    width: 120px !important;
    height: 120px !important;
  }

  .vue-dropzone>.dz-preview .dz-remove {
    margin: 7px 10px -6px 10px !important;
    font-size: 0.7rem !important;
  }
</style>